/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { catchError, mergeMap, Observable, of } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { RedirectToLogin } from '../state/auth.actions';
import { RequestedRoute } from '../state/auth.model';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
    constructor(private store: Store) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            map((event) => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.success === false && event.body.fatal) {
                        if (event.body.section) {
                            switch (event.body.section) {
                                case 'license':
                                    throw new Error(`License Error: ${event.body.message}`);
                                case 'auth':
                                    const requestedRoute: RequestedRoute = {
                                        url: request.url,
                                        queryParams: request.params,
                                    };
                                    setTimeout(() => this.store.dispatch(new RedirectToLogin(requestedRoute)), 0);
                                    break;
                            }
                        } else if (event.body.message) {
                            throw new Error(`Server Exception: ${event.body.message}`);
                        }
                    }
                }
                return event;
            }),
            mergeMap((event: HttpEvent<any>) => {
                return of(event).pipe(
                    catchError((error, caught) => {
                        console.log('Caught in ErrorHttpInterceptor', error);
                        return caught;
                    })
                )
            })
        );
    }
}
